export default __webpack_public_path__ + "static/media/banner-canada-day.cdba5db3.png";